module.exports = __webpack_public_path__ + "img/logo-aneel-sidebar.19ce9df8.png";